/**
 * User-facing API error messages (timeouts, 503 busy, etc.)
 */
export function getApiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (!err) return fallback;

  const status = err.response?.status;
  const serverMsg = err.response?.data?.message;

  if (status === 503 || status === 504) {
    return (
      serverMsg ||
      'The server is busy loading data. Please wait a few seconds and try again.'
    );
  }

  if (err.code === 'ECONNABORTED' || /timeout.*exceeded/i.test(String(err.message || ''))) {
    return 'The request took too long. The server may be under heavy load — please wait a moment and try again.';
  }

  if (err.request && !err.response) {
    return 'Could not reach the server. Check your connection or try again shortly.';
  }

  return serverMsg || err.message || fallback;
}

export function isRetryableApiError(err) {
  if (!err) return false;
  if (err.code === 'ECONNABORTED') return true;
  const status = err.response?.status;
  return status === 503 || status === 504 || status === 502;
}
